/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Search from '../../assets/images/Search.png';
import NoResults from '../../assets/images/NoResults.png';
import styles from './ZeroSearchHandler.module.css';
const HANDLER_TYPE = {
    zeroState: Search,
    noResults: NoResults,
};

const ZeroSearchHandler = ({ handlerType, header, subHeader, children }) => (
    <div className={styles.handlerContainer}>
        <h1 className={styles.handler_header}>{header}</h1>
        <h4 className={styles.handler_subHeader}>{subHeader}</h4>
        {children}
        <img src={HANDLER_TYPE[handlerType]} alt="Handler" className={styles[handlerType]} />
    </div>
);

ZeroSearchHandler.defaultProps = {
    children: <span />,
};
ZeroSearchHandler.propTypes = {
    handlerType: PropTypes.string.isRequired,
    header: PropTypes.string.isRequired,
    subHeader: PropTypes.string.isRequired,
    children: PropTypes.any,
};
export default ZeroSearchHandler;
